import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM ROTATION files
 * 
 * Handles rotation and stick-slip measurements:
 * - RPM (revolutions per minute)
 * - RPM_MIN, RPM_MAX (min/max RPM values)
 * - STICK_SLIP (stick-slip severity)
 * - SSI (stick-slip index)
 */
export class SmartDmRotationParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'RPM': 'RPM',
      'RPM_MIN': 'RPM',
      'RPM_MAX': 'RPM',
      'STICK_SLIP': 'severity',
      'SSI': 'index'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'ROTATION',
      'JAE_SMARTDM_ROTATION',
      unitMappings
    );
  }
} 